/* eslint-disable no-unused-vars */
/* eslint-disable */
import { ICommonDropdownOption, RegularButton } from 'pg-ui-library';
import React, { useEffect, useLayoutEffect, useState } from 'react';
import { useActions } from 'src/hooks/useActions';
import { useTypedSelector } from 'src/hooks/useTypedSelector';
import { Gender, IPage, MaritalStatus, RelationshipType, Support, Level, Ticket } from 'src/interfaces';
import { IPersonalInformation } from 'src/interfaces/personal-info';
import AddressForm from './components/address-form';
import ContactsForm from './components/contacts-form';

import GeneralInfoForm from './components/general-info-form';
import WorkLocationForm from './components/work-location-form';
import { MainContainer, Separator, StickHeader, StickHeaderLinks, ProfileHeading } from './styles';
import { useTranslation } from 'react-i18next';
import { SecurityQuesModal } from './components/security-question-modal';
import DistributionForm from './components/distribution-form';
import BankForm from './components/bank-form';

type SubCategoryOption = {
  key: string;
  label: string;
  value: string;
};

// Define the type for support desk submodules with string keys
type SupportDeskSubmodules = {
  [key: string]: SubCategoryOption[];
};

// Define the enum or constants for support modules if you have them
enum SupportTicketModule {
  PAYROLL = 'PAYROLL',
  HR_PROFILE = 'HR_PROFILE',
  BENEFITS = 'BENEFITS',
  TAX = 'TAX',
}
export const maritalStatusOptions: ICommonDropdownOption[] = [
  {
    key: '1',
    label: MaritalStatus.SINGLE,
    value: MaritalStatus.SINGLE,
  },
  {
    key: '2',
    label: MaritalStatus.MARRIED,
    value: MaritalStatus.MARRIED,
  },
  {
    key: '3',
    label: MaritalStatus.DIVORCED,
    value: MaritalStatus.DIVORCED,
  },
  {
    key: '4',
    label: MaritalStatus.NOT_APPLICABLE,
    value: MaritalStatus.NOT_APPLICABLE,
  },
  {
    key: '5',
    label: RelationshipType.DAUGHTER,
    value: RelationshipType.DAUGHTER,
  },
];

export const genderOptions: ICommonDropdownOption[] = [
  {
    key: '0',
    label: '',
    value: '',
  },
  {
    key: '1',
    label: Gender.MALE,
    value: Gender.MALE,
  },
  {
    key: '2',
    label: Gender.FEMALE,
    value: Gender.FEMALE,
  },
  {
    key: '3',
    label: Gender.TRANSGENDER,
    value: Gender.TRANSGENDER,
  },
  {
    key: '4',
    label: Gender.NON_BINARY,
    value: Gender.NON_BINARY,
  },
  {
    key: '4',
    label: Gender.QUEER,
    value: Gender.QUEER,
  },
  {
    key: '4',
    label: Gender.NOT_APPLICABLE,
    value: Gender.NOT_APPLICABLE,
  },
];

export const levelOptions: ICommonDropdownOption[] = [
  {
    key: '1',
    label: Level.LOW,
    value: Level.LOW,
  },
  {
    key: '2',
    label: Level.NORMAL,
    value: Level.NORMAL,
  },
  {
    key: '3',
    label: Level.HIGH,
    value: Level.HIGH,
  },
  {
    key: '4',
    label: Level.URGENT,
    value: Level.URGENT,
  },
];
export const myticketOptions: ICommonDropdownOption[] = [
  {
    key: '0',
    label: Ticket.ALL_TICKETS,
    value: Ticket.ALL_TICKETS,
  },
  {
    key: '1',
    label: Ticket.OPEN,
    value: Ticket.OPEN,
  },
  {
    key: '2',
    label: Ticket.ON_HOLD,
    value: Ticket.ON_HOLD,
  },
  {
    key: '3',
    label: Ticket.SOLVED,
    value: Ticket.SOLVED,
  },
  {
    key: '4',
    label: Ticket.CANCELLED,
    value: Ticket.CANCELLED,
  },
];
export const TicketOptions: ICommonDropdownOption[] = [
  {
    key: '0',
    label: '',
    value: '',
  },
  {
    key: '1',
    label: Support.PAYROLL,
    value: Support.PAYROLL,
  },
  {
    key: '2',
    label: Support.BENEFITS,
    value: Support.BENEFITS,
  },
  {
    key: '3',
    label: Support.TAX,
    value: Support.TAX,
  },
  {
    key: '4',
    label: 'Hr Profile',
    value: Support.hr_profile,
  },
  {
    key: '5',
    label: Support.PERSONAL_DETAILS,
    value: Support.PERSONAL_DETAILS,
  },
];
export const supportDeskOptions: ICommonDropdownOption[] = [
  {
    key: '1',
    label: 'Payroll',
    value: Support.PAYROLL,
  },
  {
    key: '2',
    label: 'Benefits',
    value: Support.BENEFITS,
  },
  {
    key: '3',
    label: 'Tax',
    value: Support.TAX,
  },
  {
    key: '4',
    label: 'Profile',
    value: Support.hr_profile,
  },
  // {
  //   key: '5',
  //   label: Support.PERSONAL_DETAILS,
  //   value: Support.PERSONAL_DETAILS,
  // },
];

export const supportDeskSubmodules: SupportDeskSubmodules = {
  ['pay_history']: [
    { key: '1', label: 'Bonus/Commissions', value: 'Bonus/Commissions' },
    { key: '2', label: 'Expense Reimbursement', value: 'Expense Reimbursement' },
    { key: '3', label: 'Garnishments', value: 'Garnishments' },
    { key: '4', label: 'Holiday Pay', value: 'Holiday Pay' },
    { key: '5', label: 'Leave Accruals and Balances', value: 'Leave Accruals and Balances' },
    { key: '6', label: 'Overpayments', value: 'Overpayments' },
    { key: '7', label: 'Paid Time Off', value: 'Paid Time Off' },
    { key: '8', label: 'Payroll Deductions', value: 'Payroll Deductions' },
    { key: '9', label: 'Paystatements', value: 'Paystatements' },
    { key: '10', label: 'Refund or Payroll Adjustments', value: 'Refund or Payroll Adjustments' },
    { key: '11', label: 'Salary/Wages', value: 'Salary/Wages' },
    { key: '12', label: 'Severance Pay', value: 'Severance Pay' },
    { key: '13', label: 'Sick Pay', value: 'Sick Pay' },
    { key: '14', label: 'Timesheet/Attendance Records', value: 'Timesheet/Attendance Records' },
    { key: '15', label: 'Underpayments', value: 'Underpayments' },
    { key: '16', label: 'Unused Vacation/Sick Leave Payouts', value: 'Unused Vacation/Sick Leave Payouts' },
  ],
  ['hr_profile']: [
    { key: '1', label: 'Personal Info', value: 'Personal Info' },
    { key: '2', label: 'Direct Deposit Change', value: 'Direct Deposit Change' },
    { key: '3', label: 'Mobile Number / Email Address Change', value: 'Mobile Number / Email Address Change' },
    { key: '4', label: 'Name Change', value: 'Name Change' },
    { key: '5', label: 'Location / Address Change', value: 'Location / Address Change' },
  ],
  ['benefits']: [
    { key: '1', label: 'New Hire', value: 'NEW HIRE' },
    { key: '2', label: 'Open Enrollment', value: 'Open Enrollment' },
    { key: '3', label: 'Qualifying Life Events', value: 'Qualifying Life Events' },
    { key: '4', label: 'Active', value: 'Active' },
    { key: '5', label: 'Enrollment History', value: 'Enrollment History' },
    { key: '6', label: 'Unemployment', value: 'Unemployment' },
    { key: '7', label: 'Garnishment', value: 'Garnishment' },
    { key: '8', label: 'W2/W4', value: 'W2/W4' },
    { key: '9', label: 'Benefits Eligibility', value: 'Benefits Eligibility' },
    { key: '10', label: 'QLE documents', value: 'QLE documents' },
    { key: '11', label: 'Vendor ID Card information', value: 'Vendor ID Card information' },
    { key: '12', label: 'Leaves and Disability', value: 'Leaves and Disability' },
    { key: '13', label: 'Workers Compensation', value: 'Workers Compensation' },
    { key: '14', label: '401(k) (Empower)', value: '401(k) (Empower)' },
    { key: '15', label: 'Enrollment (New Hires)', value: 'Enrollment (New Hires)' },
    { key: '16', label: '1095/1094', value: '1095/1094' },
    { key: '17', label: 'ADA Accommodations', value: 'ADA Accommodations' },
    { key: '18', label: 'Beneficiary Forms', value: 'Beneficiary Forms' },
    { key: '19', label: 'EOI (Evidence of Insurability)', value: 'EOI (Evidence of Insurability)' },
    { key: '20', label: 'ESS Portal', value: 'ESS Portal' },
    { key: '21', label: 'General Questions', value: 'General Questions' },
    { key: '22', label: 'Dependents', value: 'Dependents' },
  ],
  ['tax_forms']: [
    { key: '1', label: 'Tax Exemptions', value: 'Tax Exemptions' },
    { key: '2', label: 'Excess Tax Withheld', value: 'Excess Tax Withheld' },
    { key: '3', label: 'Incorrect Tax Withholding', value: 'Incorrect Tax Withholding' },
    { key: '4', label: 'State Forms', value: 'State Forms' },
    { key: '5', label: 'Tax Filing Status', value: 'Tax Filing Status' },
  ],
};

export const relationshipOptions: ICommonDropdownOption[] = [
  {
    key: '3',
    label: RelationshipType.SPOUSE,
    value: RelationshipType.SPOUSE,
  },
  {
    key: '3',
    label: RelationshipType.HUSBAND,
    value: RelationshipType.HUSBAND,
  },
  {
    key: '8',
    label: RelationshipType.CHILD,
    value: RelationshipType.CHILD,
  },
  {
    key: '6',
    label: RelationshipType.Parent,
    value: RelationshipType.Parent,
  },
  {
    key: '7',
    label: RelationshipType.Sibling,
    value: RelationshipType.Sibling,
  },
  {
    key: '9',
    label: RelationshipType.DOMESTIC_PARTNER_LABEL,
    value: RelationshipType.DOMESTIC_PARTNER,
  },
  {
    key: '10',
    label: RelationshipType.EX_SPOUSE_LABEL,
    value: RelationshipType.EX_SPOUSE,
  },
  {
    key: '11',
    label: RelationshipType.FAMILY_CONTACT_LABEL,
    value: RelationshipType.FAMILY_CONTACT,
  },
  {
    key: '12',
    label: RelationshipType.OTHER_CONTACT_LABEL,
    value: RelationshipType.OTHER_CONTACT,
  },
  {
    key: '13',
    label: RelationshipType.NOT_APPLICABLE,
    value: RelationshipType.NOT_APPLICABLE,
  },
];

export enum BankType {
  SAVINGS = 'savings',
  CHECKING = 'Checking',
}

export const bankTypeOptions: ICommonDropdownOption[] = [
  {
    key: '1',
    label: BankType.SAVINGS.charAt(0).toUpperCase() + BankType.SAVINGS.slice(1), // "Savings"
    value: BankType.SAVINGS,
  },
  {
    key: '2',
    label: BankType.CHECKING.charAt(0).toUpperCase() + BankType.CHECKING.slice(1), // "Current"
    value: BankType.CHECKING,
  },
];

export interface PersonalInfoForm {
  personalInfo?: IPersonalInformation;
  isResident?: boolean;
}

const PersonalInfoPage: React.FC<IPage> = props => {
  const { t } = useTranslation();
  const { data } = useTypedSelector(state => state.personalInfo);
  const [scrollPosition, setScrollPosition] = useState(0);
  const { getPersonalInfo } = useActions();
  const [quesModalIsOpen, setQuesModalIsOpen] = useState<boolean>(false);

  const handleScroll = () => {
    const position = window.pageYOffset;
    setScrollPosition(position);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    getPersonalInfo();
  }, []);
  const username = data.personalInfo?.username || '';

  const showStick = scrollPosition > 100;

  return (
    <MainContainer>
      <SecurityQuesModal username={username} isOpen={quesModalIsOpen} setIsOpen={setQuesModalIsOpen} />
      <div>
        <StickHeader showStick={showStick}>
          <StickHeaderLinks>
            <a href="#general-info">Personal Info</a>
            <a href="#address">Address</a>
            <a href="#dependents-contacts">Dependents</a>
            <a href="#bank_module">Bank Module</a>
            <a href="#work-location">Work Location</a>
          </StickHeaderLinks>
        </StickHeader>
        <ProfileHeading>
          <div style={{ width: '95%' }}>HR Profile</div>
          <div>
            <RegularButton type="button" onClick={() => setQuesModalIsOpen(true)} disabled={!username}>
              {t('btn.security')}
            </RegularButton>
          </div>
        </ProfileHeading>
        <div id="general-info">
          <GeneralInfoForm personalInfo={data.personalInfo} />
        </div>
        <Separator />
        <div
          id="distribution-form"
          style={{ marginTop: '10px', background: 'white', boxShadow: '0px 0px 6px #E3E3E3', borderRadius: '10px' }}
        >
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <DistributionForm personalInfo={data.personalInfo} />
          </div>
        </div>
        <Separator />
        <div
          id="address"
          style={{ marginTop: '20px', background: 'white', boxShadow: '0px 0px 6px #E3E3E3', borderRadius: '10px' }}
        >
          <AddressForm personalInfo={data.personalInfo} />
        </div>
        <Separator />
        <div
          id="dependents-contacts"
          style={{ marginTop: '10px', background: 'white', boxShadow: '0px 0px 6px #E3E3E3', borderRadius: '10px' }}
        >
          <ContactsForm personalInfo={data.personalInfo} />
        </div>
        <Separator />
        <div
          id="work-location"
          style={{ marginTop: '10px', background: 'white', boxShadow: '0px 0px 6px #E3E3E3', borderRadius: '10px' }}
        >
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <WorkLocationForm personalInfo={data.personalInfo} />
          </div>
        </div>
        <Separator />
        <div
          id="Bank Module"
          style={{ marginTop: '20px', background: 'white', boxShadow: '0px 0px 6px #E3E3E3', borderRadius: '10px' }}
        >
          <BankForm personalInfo={data.personalInfo} />
        </div>
        <Separator />
        <div
          id="work-location"
          style={{ marginTop: '10px', background: 'white', boxShadow: '0px 0px 6px #E3E3E3', borderRadius: '10px' }}
        >
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <WorkLocationForm personalInfo={data.personalInfo} isResident={true} />
          </div>
        </div>
      </div>
    </MainContainer>
  );
};

export default PersonalInfoPage;
